import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Landing, About, Skills, Services, Projects, Testimonials, Contacts} from '../../components'
import { headerData } from '../../data/headerData'

function Main() {
    return (
        <div>
            <Helmet>
                <title>{headerData.pageTitle} </title>
            </Helmet>

            <Navbar />
            <Landing />
            <About />
            <Skills />
            <Services />
            <Projects />
            <Testimonials />
            <Contacts />

        </div>
    )
}

export default Main
